module.exports = __webpack_public_path__ + "static/media/betaald.5bc52846.svg";